import { useTranslation } from 'react-i18next';

import { Card } from '@/components/ui/card';
import { DashboardFilterBar } from '@/features/dashboard-filters';

import { useServiceUsers } from '../lib/use-service-users';
import { PageHeader, ServiceStats, ActivityChart, TopListsGrid, ServiceSummary } from './components';

export function ServiceUsersPage() {
  const { t } = useTranslation();
  const { data, formattedStats, isLoading, error, options, updateOption } = useServiceUsers();

  if (error) {
    return (
      <div className="p-6">
        <Card className="p-6">
          <p className="text-destructive">Error loading service users data</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="p-6 space-y-6">
      <PageHeader title={t('welcome_serviceusers_label', 'Service Users')} />

      <DashboardFilterBar variant="service" options={options} onOptionChange={updateOption} />

      {data && formattedStats && (
        <>
          <ServiceStats stats={formattedStats} />
          <ActivityChart data={data.serviceUsers} isLoading={isLoading} />
          <TopListsGrid topProducts={data.topProducts} topServiceUsers={data.topServiceUsers} isLoading={isLoading} />
          <ServiceSummary stats={formattedStats} />
        </>
      )}
    </div>
  );
}
